<template>
  <div class="header">
    <div class="logo"></div>
    <div class="menu">
      <div class="isSLevel" v-if="isSLevel"></div>
      <ul class="wrap">
        <li @click="toHome"><span>首页</span></li>
        <li
          v-for="(item, key) in menuList"
          :key="key"
          @mouseover="showSLevel(item.children && item.children.length > 0)"
          @mouseout="hideSLevel(item.children && item.children.length > 0)"
        >
          <span @click="open(item.id)">{{ item.colValue }}</span>
          <template v-if="item.children && item.children.length > 0">
            <div class="sLevel" :class="{ ml: item.id === 7 }">
              <span v-for="(titem, tkey) in item.children" :key="tkey" @click="open(item.id, titem.id)">{{
                titem.colValue
              }}</span>
            </div>
          </template>
        </li>
        <div class="search">
          <input type="text" v-model.trim="keyword" placeholder="输入关键词搜索" @keyup.enter="search" />
          <span><i class="el-icon-search" @click="search"></i></span>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  components: {},
  data() {
    return {
      keyword: '',
      isSLevel: false,
      menuList: [
        {
          id: 1,
          colValue: '协会动态'
        },
        {
          id: 2,
          colValue: '通知公告'
        },
        {
          id: 3,
          colValue: '政策法规',
          children: [
            {
              id: 31,
              colValue: '国家'
            },
            {
              id: 32,
              colValue: '广东'
            },
            {
              id: 34,
              colValue: '珠三角地市'
            },
            {
              id: 35,
              colValue: '其他地市'
            }
          ]
        },
        {
          id: 8,
          colValue: '行业资讯',
          children: [
            {
              id: 82,
              colValue: '广东'
            },
            {
              id: 83,
              colValue: '其他地区'
            }
          ]
        },
        {
          id: 4,
          colValue: '会员服务',
          children: [
            {
              id: 43,
              colValue: '会员风采'
            },
            {
              id: 41,
              colValue: '会员服务简介'
            },
            {
              id: 42,
              colValue: '业务指南'
            },
            {
              id: 44,
              colValue: '有问有答'
            },
            {
              id: 45,
              colValue: '专业书刊'
            },
            {
              id: 46,
              colValue: '业务探讨'
            }
          ]
        },
        {
          id: 5,
          colValue: '教育培训',
          children: [
            {
              id: 51,
              colValue: '培训信息'
            },
            {
              id: 52,
              colValue: '微课堂'
            }
          ]
        },
        {
          id: 6,
          colValue: '诚信自律',
          children: [
            {
              id: 61,
              colValue: '自律公约'
            },
            {
              id: 62,
              colValue: '诚信资讯'
            },
            {
              id: 63,
              colValue: '诚信法规'
            },
            {
              id: 64,
              colValue: '公约成员'
            }
          ]
        },
        {
          id: 10,
          colValue: '人才供需'
        },
        {
          id: 7,
          colValue: '关于协会',
          children: [
            {
              id: 71,
              colValue: '协会介绍'
            },
            {
              id: 72,
              colValue: '协会章程'
            },
            {
              id: 73,
              colValue: '业务范围'
            },
            {
              id: 74,
              colValue: '会员名单'
            },
            {
              id: 75,
              colValue: '联系我们'
            },
            {
              id: 76,
              colValue: '协会架构'
            },
            {
              id: 77,
              colValue: '专业委员会'
            },
            {
              id: 78,
              colValue: '入会邀请函'
            }
          ]
        }
      ]
    };
  },
  mounted() {
    if (this.$route.params.keyword) {
      this.keyword = this.$route.params.keyword;
    }
  },
  methods: {
    open(val, sVal) {
      let routeData;
      if (val === 10) {
        routeData = this.$router.resolve({
          name: 'JobList'
        });
      } else {
        routeData = this.$router.resolve({
          name: 'List',
          params: { type: val },
          query: {
            sType: sVal
          }
        });
      }
      window.open(routeData.href, '_blank');
    },
    search() {
      if (!this.keyword || this.keyword.trim().replace(/\s/g, '') === '') {
        this.$message.error('请输入搜索内容');
        return false;
      }
      if (this.$route.name === 'Search') {
        this.$router.replace({
          name: 'Search',
          params: { keyword: this.keyword }
        });
        this.$emit('toSearch', this.keyword);
      } else {
        let routeData = this.$router.resolve({
          name: 'Search',
          params: { keyword: this.keyword }
        });
        window.open(routeData.href, '_blank');
      }
    },
    toHome() {
      let routeData = this.$router.resolve({
        name: 'Home'
      });
      window.open(routeData.href, '_blank');
    },
    showSLevel(val) {
      if (!val) {
        return false;
      }
      this.isSLevel = true;
    },
    hideSLevel(val) {
      if (!val) {
        return false;
      }
      this.isSLevel = false;
    }
  }
};
</script>

<style lang="less" scoped>
.header {
  background: #015bb3;
  .logo {
    height: 240px;
    background: url('~@img/header.jpg') no-repeat;
    background-position: center top;
  }
  .menu {
    position: relative;
    background: #136ef6;
    box-shadow: 0 -5px 5px rgba(0, 0, 0, 0.5);
    height: 50px;
    .isSLevel {
      position: absolute;
      top: 48px;
      height: 48px;
      left: 0;
      right: 0;
      width: 100%;
      z-index: 3;
      background: #fff;
    }
    ul {
      white-space: nowrap;
      box-sizing: border-box;
      //padding: 0 20px;
      font-size: 0;
      li {
        position: relative;
        display: inline-block;
        vertical-align: middle;
        & > span {
          display: block;
          font-size: 20px;
          color: #fff;
          font-weight: 600;
          height: 48px;
          line-height: 48px;
          padding: 0 10px;
          cursor: pointer;
          &:hover {
            opacity: 0.85;
          }
        }
        &:hover {
          background: #207acf;
          span {
            color: #fff;
          }
          .sLevel {
            display: block;
            background: #fff;
          }
        }
        .sLevel {
          display: none;
          position: absolute;
          top: 48px;
          left: 50%;
          border-top: 0;
          font-size: 0;
          min-width: 100%;
          overflow: hidden;
          z-index: 5;
          transform: translateX(-50%);

          &:after {
            position: absolute;
            top: 0;
            left: 50%;
            content: '';
            width: 0;
            height: 0;
            border-width: 8px;
            margin-left: -8px;
            border-style: solid;
            border-color: #207acf transparent transparent transparent;
            z-index: 5;
          }

          &.ml {
            margin-left: -134px;
            &:after {
              margin-left: 126px;
            }
          }
          span {
            display: inline-block;
            padding: 0 6px;
            font-size: 18px;
            color: #055db1;
            line-height: 48px;
            cursor: pointer;
          }
        }
      }
      .search {
        float: right;
        border: 1px solid #7376d9;
        font-size: 0;
        white-space: nowrap;
        margin-top: 9px;
        input {
          display: inline-block;
          vertical-align: middle;
          width: 127px;
          height: 27px;
          font-size: 14px;
          color: #333;
          box-sizing: border-box;
          padding: 0 12px;
        }
        span {
          display: inline-block;
          vertical-align: middle;
          width: 30px;
          height: 27px;
          font-size: 14px;
          background: #c2c2c2;
          text-align: center;
          color: #1d2199;
          line-height: 27px;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
